module.exports = __webpack_public_path__ + "assets/570fc3c147980f1d286f40bc9e699c18.ttf";